import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import supabase from '../../supabase/supabase';
import { AUDIT_TABLE } from '../../utils/auditLogger';

const { FiFileText, FiSearch, FiShield, FiUserCheck } = FiIcons;

export default function AuditLogsViewer() {
  const [logs, setLogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchLogs = async () => {
    const { data } = await supabase
      .from(AUDIT_TABLE)
      .select('*')
      .order('created_at', { ascending: false })
      .limit(100);
    if (data) setLogs(data);
  };

  useEffect(() => {
    fetchLogs();
    const channel = supabase
      .channel('audit_logs_realtime')
      .on('postgres_changes', { event: '*', schema: 'public', table: AUDIT_TABLE }, fetchLogs)
      .subscribe();
    return () => supabase.removeChannel(channel);
  }, []);

  const filteredLogs = logs.filter(
    (log) =>
      log.action_type.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.admin_username.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.target_user.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.details.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <section className="rounded-2xl border border-white/10 bg-[#111] p-5 space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 border-b border-white/5 pb-3">
        <div className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-500/10 text-blue-400">
            <SafeIcon icon={FiFileText} size={18} />
          </span>
          <div>
            <h3 className="font-semibold text-white text-sm sm:text-base">Registro de Auditoría de Moderación</h3>
            <p className="text-xs text-gray-500">Historial inmutable de acciones ejecutadas por administradores</p>
          </div>
        </div>
        <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-xl px-3 py-1.5">
          <SafeIcon icon={FiSearch} size={12} className="text-gray-400" />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Buscar en auditoría..."
            className="bg-transparent text-xs text-white outline-none w-36 sm:w-48 placeholder:text-gray-500"
          />
        </div>
      </div>

      <div className="space-y-2 max-h-[450px] overflow-y-auto">
        {filteredLogs.map((log) => (
          <div key={log.id} className="p-3 bg-black/40 border border-white/5 rounded-xl flex items-start justify-between gap-3 text-xs">
            <div className="space-y-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="px-2 py-0.5 rounded bg-blue-500/10 text-blue-400 font-bold text-[10px]">
                  {log.action_type}
                </span>
                <span className="text-gray-300 font-medium">por @{log.admin_username}</span>
                {log.target_user && (
                  <span className="text-gray-400 font-semibold truncate">→ {log.target_user}</span>
                )}
              </div>
              <p className="text-gray-400 text-[11px] break-words">{log.details}</p>
            </div>
            <time className="text-[10px] text-gray-500 shrink-0">
              {new Date(log.created_at).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' })}
            </time>
          </div>
        ))}

        {filteredLogs.length === 0 && (
          <p className="text-center py-8 text-gray-500 text-xs">No hay registros de auditoría registrados.</p>
        )}
      </div>
    </section>
  );
}